import { LOGIN } from "@/shared/constants/routes";
import { Text } from "@orgmym/leeloo-core";
import { useTranslation } from "react-i18next";

import { Link } from "@/shared/components/link/Link";

export const LoginLink = ({ ...props }) => {
  const { t } = useTranslation();

  return (
    <Text {...props}>
      {t("common_already_have_an_account")}{" "}
      <Link to={LOGIN}>{t("common_login_button")}</Link>
    </Text>
  );
};
